// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.privacy-container {
  width: 90%;
  margin: auto;
  padding: 20px 0px;
}

h6 {
  font-weight: 700 !important;
}

.privacy-section {
  line-height: 20px;
}

.intro-head {
  text-align: center;
  padding: 25px 0px 20px 0px;
}

.upper-type-list {
  list-style-type: upper-alpha;
}

.roman-type-list {
  list-style-type: lower-roman;
}`, "",{"version":3,"sources":["webpack://./src/pages/MXPrivacy/mxprivacy.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,YAAA;EACA,iBAAA;AACJ;;AAEA;EACI,2BAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,0BAAA;AACJ;;AAEA;EACI,4BAAA;AACJ;;AAEA;EACI,4BAAA;AACJ","sourcesContent":[".privacy-container {\n    width: 90%;\n    margin: auto;\n    padding: 20px 0px;\n}\n\nh6 {\n    font-weight: 700 !important;\n}\n\n.privacy-section {\n    line-height: 20px;\n}\n\n.intro-head {\n    text-align: center;\n    padding: 25px 0px 20px 0px;\n}\n\n.upper-type-list {\n    list-style-type: upper-alpha;\n}\n\n.roman-type-list {\n    list-style-type: lower-roman;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
